module.exports = __webpack_public_path__ + "static/media/presidentsQuiz.4d8bd2a8.png";